import { getPageLayout } from '@/components/Common/PageLayout';
import {
  SOURCING_AND_PRODUCTION_CONTENT,
  SOURCING_AND_PRODUCTION_UPLOADER_CONTENT,
} from '@/shared/constants/platform-pages-constants';
import PlatformPage from '@/components/Platform';
import React, { ReactElement } from 'react';
import TitleHero from '@/components/Platform/TitleHero';
import MembershipCards from '@/components/Platform/MembershipCards';
import PlatformV2Hero from '@/components/Platform/PlatformV2Hero';
import { NextPageWithLayout } from '@/pages/_app';
import { InferGetStaticPropsType } from 'next';
import './index.less';
import FAQContainer from '@/components/Common/FAQContainer';
import { SEO_PLATFORM_SOURCING_AND_PRODUCTION_PRODUCTS } from '@/shared/constants/seo';
import Script from 'next/script';
import { faqJsonLd } from '@/shared/seo/jsonld';

export async function getStaticProps() {
  const heroData = SOURCING_AND_PRODUCTION_UPLOADER_CONTENT['products'];

  return {
    props: {
      heroData,
      resolvedUrl: '/platform/sourcing-and-production/products',
    },
    revalidate: 3600,
  };
}

const ProductsPathPage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({ heroData }) => {
  return (
    <div className="sourcing-path-page-wrap">
      <TitleHero heroData={heroData} />
      <PlatformV2Hero />
      <MembershipCards />
      <PlatformPage content={SOURCING_AND_PRODUCTION_CONTENT} utmSource="sourcing_and_production" />
      <FAQContainer faq={SEO_PLATFORM_SOURCING_AND_PRODUCTION_PRODUCTS} />
      <Script
        id="faq-seo-platform-sourcing-and-production-products"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqJsonLd(SEO_PLATFORM_SOURCING_AND_PRODUCTION_PRODUCTS)),
        }}
      />
    </div>
  );
};

ProductsPathPage.getLayout = (page: ReactElement) => {
  const { heroData, resolvedUrl } = page.props;
  return getPageLayout({
    title: `${heroData?.title} | Pietra`,
    description: heroData?.subtitle,
    image: heroData?.image,
    path: resolvedUrl,
    hideFooter: false,
  })(page);
};
export default ProductsPathPage;
